import '@planne-software/uni/v2/styles/index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import I18nProvider from '@src/i18n/I18nProvider';

import { store } from './core/store';

import Base from '@src/pages/DirectLink/Base';
import Home from '@src/pages/DirectLink/Home';
import Checkout from '@src/pages/DirectLink/Checkout';
import Process from './pages/DirectLink/Process';
import BodySetup from '@src/components/BodySetup/BodySetup';
import { ThemeProvider } from '@planne-software/uni/mui/material';
import { lightTheme } from '@planne-software/uni/themes';
import NewLink from './pages/DirectLink/NewLink';

((doc: Document) => {
  const container = doc.getElementById('app');
  const root = createRoot(container!);

  root.render(
    <Provider store={store}>
      <I18nProvider>
        <ThemeProvider theme={lightTheme}>
          <BrowserRouter>
            <Routes>
              <Route path='/link/:apiKey/:linkCode' element={<Base />}>
                <Route index element={<Home />} />

                <Route path='process' element={<Process />} />

                <Route path='checkout' element={<Checkout />} />
              </Route>
              <Route path='/newlink/:apiKey/:linkCode' element={<NewLink />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>

        <BodySetup />
      </I18nProvider>
    </Provider>,
  );
})(document);
